import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

//Account Redux states
import { QUERYSTATUS_TASK } from './actionTypes';
import { queryTaskStatusStartSuccessful, queryTaskStatusStartFailed } from './actions';

// Include call API
import { getTasksAPI } from "../../../api/tasks";

const tasksAPI = getTasksAPI();


// Is user register successfull then direct plot user in redux.
function* queryTaskStatusStart(action) {

    try {
      yield call(tasksAPI.querytaskStatusStart, action.payload.token);
       yield put(queryTaskStatusStartSuccessful(true));

    } catch (error) {
        console.log("errorCatch",error)
        yield put(queryTaskStatusStartFailed(error));
    }
}

export function* watchQueryStatusTaskRegister() {
    yield takeEvery(QUERYSTATUS_TASK, queryTaskStatusStart);
}

function* queryTaskStatusStartSaga() {
    yield all([fork(watchQueryStatusTaskRegister)]);
}

export default queryTaskStatusStartSaga;